import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';// Adjust path as needed
import swal from 'sweetalert';
import { SignUP } from '../../../components/actions/auth';
import Loader from '../../../components/utils/Loader';

const Signup = () => {
  const [isConfirmPassword, setIsConfirmPassword] = useState(false);
  const [isRevealPassword, setIsRevealPassword] = useState(false);
  const [finalData, setFinalData] = useState({});
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const industries = [
    'Automotive',
    'E-Commerce',
    'Technology',
    'Healthcare',
    'Finance',
    'Retail',
    'Education',
    'Manufacturing',
    'Food & Beverage',
    'Real Estate',
    'Other',
  ];

  const needOptions = [
    'Launch a new loyalty program',
    'Replace existing loyalty program',
    'Need more information on loyalty setup',
  ];

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    contactNumber: '',
    newPassword: '',
    confirmPassword: '',
    industry: '',
    companyName: '',
    rewardportal: '',
    projectDetails: '',
    tAndC: false,
    needSelectedTypeId: '',
  });

  const { name, email, contactNumber, newPassword, confirmPassword, industry, companyName, projectDetails, tAndC, needSelectedTypeId } = formData;

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    let updatedFormData = { ...formData, [name]: type === 'checkbox' ? checked : value };

    if (name === 'companyName') {
      const formattedRewardPortal = value.replace(/\s+/g, '').toLowerCase().substring(0, 10);
      updatedFormData = { ...updatedFormData, rewardportal: formattedRewardPortal };
    }

    setFormData(updatedFormData);

    if (errors[name]) {
      setErrors({ ...errors, [name]: '' });
    }
  };

  useEffect(() => {
    setFinalData({
      name,
      code: 'abc',
      country: 'country',
      timeZone: 'timeZone',
      city: 'city',
      status: 0,
      isRedemption: 0,
      merchantClientId: 'merchantClientId',
      merchantClientSecret: 'merchantClientSecret',
      remarks: 'remarks',
      lastOtp: 'lastOtp',
       adminCode:"",
        isAdmin:false,
      company: companyName,
      portalName: formData.rewardportal,
      mobile: contactNumber,
      description: projectDetails,
      email,
      purpose: needSelectedTypeId,
      industry,
      password: newPassword,
    });
  }, [formData]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};

    // Basic validation
    if (!name) newErrors.name = 'Please enter your name';
    if (!email) newErrors.email = 'Please enter your email';
    else if (!/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)) {
      newErrors.email = 'Enter a valid email';
    }
    if (!newPassword) newErrors.newPassword = 'Please enter a password';
    else if (newPassword.length < 6) newErrors.newPassword = 'Password must be at least 6 characters';
    else if (!/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{6,16}$/.test(newPassword)) {
      newErrors.newPassword = 'Password must contain at least one uppercase, lowercase, number, and special character';
    }
    if (!confirmPassword) newErrors.confirmPassword = 'Please enter confirm password';
    else if (newPassword !== confirmPassword) newErrors.confirmPassword = 'Passwords do not match';
    if (!contactNumber) newErrors.contactNumber = 'Please enter your contact number';
    else if (!/^(?!\d*(\d)\1{7,}|0123456789|1234567890)\d{10,15}$/.test(contactNumber)) {
      newErrors.contactNumber = 'Please enter a valid number';
    }
    if (!industry) newErrors.industry = 'Please select your industry';
    if (!companyName) newErrors.companyName = 'Please enter your company name';
    if (!projectDetails) newErrors.projectDetails = 'Please enter details about your project';
    else if (projectDetails.length < 20) newErrors.projectDetails = 'Minimum length should be 20 characters';
    else if (projectDetails.length > 500) newErrors.projectDetails = 'Maximum length should be 500 characters';
    if (!needSelectedTypeId) newErrors.needSelectedTypeId = 'Please select your purpose';
    if (!tAndC) newErrors.tAndC = 'Please agree to the Terms and Conditions';

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setLoading(true);
    const response = await SignUP(finalData);
    setLoading(false);

    if (response.message === 'success') {
      swal({
        position: 'center',
        icon: 'success',
        title: 'Sent OTP to your registered email ID',
        timer: 2000,
      });
      navigate('/otp-verification', { state: { email } });
      sessionStorage.setItem('code', response?.data?.item1?.code);
    } else if (response.message === 'User Already Exist') {
      swal({
        title: 'Oops!',
        text: 'User Already Exists',
        icon: 'warning',
        button: 'oh no!',
        timer: 5000,
      });
    } else {
      swal({
        title: 'Oops!',
        text: response.message,
        icon: 'error',
        button: 'oh no!',
        timer: 5000,
      });
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      {loading && <Loader />}
      <div className="max-w-2xl w-full bg-white rounded-xl shadow-lg p-8 my-8">
        <div className="text-center mb-8">
          <div className="flex items-center justify-center gap-3 mb-4">
            <img
             src="/primexlogo.png" 
              alt="PrimeX Loyalty"
             className="w-25 h-16"
            />
          </div>
          <h2 className="text-2xl font-semibold text-gray-800">Create Account</h2>
          <p className="text-gray-600 mt-2">Join our merchant platform</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                Full Name *
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={name}
                onChange={handleChange}
                required
                className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 transition duration-200 ${errors.name ? 'border-red-500' : 'border-gray-300'}`}
                placeholder="Enter your full name"
              />
              {errors.name && <p className="text-red-500 text-sm mt-1">{errors.name}</p>}
            </div>
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                Email Address *
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={email}
                onChange={handleChange}
                required
                className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 transition duration-200 ${errors.email ? 'border-red-500' : 'border-gray-300'}`}
                placeholder="Enter your email"
              />
              {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email}</p>}
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label htmlFor="newPassword" className="block text-sm font-medium text-gray-700 mb-2">
                Password *
              </label>
              <div className="relative">
                <input
                  type={isRevealPassword ? 'text' : 'password'}
                  id="newPassword"
                  name="newPassword"
                  value={newPassword}
                  onChange={handleChange}
                  required
                  className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 transition duration-200 ${errors.newPassword ? 'border-red-500' : 'border-gray-300'}`}
                  placeholder="Create password"
                />
                <span className="absolute inset-y-0 right-0 flex items-center pr-3">
                  <svg
                    className="h-5 w-5 text-gray-400 cursor-pointer"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    onClick={() => setIsRevealPassword((prev) => !prev)}
                  >
                    {isRevealPassword ? (
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                    ) : (
                      <>
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.543 7-1.274 4.057-5.064 7-9.543 7-4.477 0-8.268-2.943-9.543-7z" />
                      </>
                    )}
                  </svg>
                </span>
              </div>
              {errors.newPassword && <p className="text-red-500 text-sm mt-1">{errors.newPassword}</p>}
            </div>
            <div>
              <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700 mb-2">
                Confirm Password *
              </label>
              <div className="relative">
                <input
                  type={isConfirmPassword ? 'text' : 'password'}
                  id="confirmPassword"
                  name="confirmPassword"
                  value={confirmPassword}
                  onChange={handleChange}
                  required
                  className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 transition duration-200 ${errors.confirmPassword ? 'border-red-500' : 'border-gray-300'}`}
                  placeholder="Confirm password"
                />
                <span className="absolute inset-y-0 right-0 flex items-center pr-3">
                  <svg
                    className="h-5 w-5 text-gray-400 cursor-pointer"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    onClick={() => setIsConfirmPassword((prev) => !prev)}
                  >
                    {isConfirmPassword ? (
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                    ) : (
                      <>
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.543 7-1.274 4.057-5.064 7-9.543 7-4.477 0-8.268-2.943-9.543-7z" />
                      </>
                    )}
                  </svg>
                </span>
              </div>
              {errors.confirmPassword && <p className="text-red-500 text-sm mt-1">{errors.confirmPassword}</p>}
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label htmlFor="contactNumber" className="block text-sm font-medium text-gray-700 mb-2">
                Contact Number *
              </label>
              <input
                type="tel"
                id="contactNumber"
                name="contactNumber"
                value={contactNumber}
                onChange={handleChange}
                required
                className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 transition duration-200 ${errors.contactNumber ? 'border-red-500' : 'border-gray-300'}`}
                placeholder="Enter your phone number"
              />
              {errors.contactNumber && <p className="text-red-500 text-sm mt-1">{errors.contactNumber}</p>}
            </div>
            <div>
              <label htmlFor="industry" className="block text-sm font-medium text-gray-700 mb-2">
                Industry *
              </label>
              <div className="relative">
                <select
                  id="industry"
                  name="industry"
                  value={industry}
                  onChange={handleChange}
                  required
                  className={`w-full px-4 py-3 pr-8 border rounded-lg focus:ring-2 focus:ring-blue-500 transition duration-200 appearance-none bg-white cursor-pointer ${errors.industry ? 'border-red-500' : 'border-gray-300'}`}
                >
                  <option value="">Select your industry</option>
                  {industries.map((ind) => (
                    <option key={ind} value={ind}>
                      {ind}
                    </option>
                  ))}
                </select>
                <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                  <svg className="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                  </svg>
                </div>
              </div>
              {errors.industry && <p className="text-red-500 text-sm mt-1">{errors.industry}</p>}
            </div>
          </div>

          <div>
            <label htmlFor="companyName" className="block text-sm font-medium text-gray-700 mb-2">
              Company Name *
            </label>
            <input
              type="text"
              id="companyName"
              name="companyName"
              value={companyName}
              onChange={handleChange}
              required
              className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 transition duration-200 ${errors.companyName ? 'border-red-500' : 'border-gray-300'}`}
              placeholder="Enter your company name"
            />
            {errors.companyName && <p className="text-red-500 text-sm mt-1">{errors.companyName}</p>}
          </div>

          <div>
            <label htmlFor="needSelectedTypeId" className="block text-sm font-medium text-gray-700 mb-2">
              Purpose *
            </label>
            <div className="relative">
              <select
                id="needSelectedTypeId"
                name="needSelectedTypeId"
                value={needSelectedTypeId}
                onChange={handleChange}
                required
                className={`w-full px-4 py-3 pr-8 border rounded-lg focus:ring-2 focus:ring-blue-500 transition duration-200 appearance-none bg-white cursor-pointer ${errors.needSelectedTypeId ? 'border-red-500' : 'border-gray-300'}`}
              >
                <option value="">Select your purpose</option>
                {needOptions.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
              <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                <svg className="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                </svg>
              </div>
            </div>
            {errors.needSelectedTypeId && <p className="text-red-500 text-sm mt-1">{errors.needSelectedTypeId}</p>}
          </div>

          <div>
            <label htmlFor="projectDetails" className="block text-sm font-medium text-gray-700 mb-2">
              Details about your Project *
            </label>
            <textarea
              id="projectDetails"
              name="projectDetails"
              value={projectDetails}
              onChange={handleChange}
              required
              maxLength={500}
              rows={4}
              className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 transition duration-200 resize-none ${errors.projectDetails ? 'border-red-500' : 'border-gray-300'}`}
              placeholder="Tell us about your project and requirements..."
            />
            <p className="text-sm text-gray-500 mt-1">{projectDetails.length}/500 characters</p>
            {errors.projectDetails && <p className="text-red-500 text-sm mt-1">{errors.projectDetails}</p>}
          </div>

          <div className="flex items-center">
            <input
              id="agree-terms"
              name="tAndC"
              type="checkbox"
              checked={tAndC}
              onChange={handleChange}
              required
              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
            />
            <label htmlFor="agree-terms" className="ml-2 block text-sm text-gray-700">
              I agree to the{' '}
              <a href="#" className="text-blue-600 hover:text-blue-800 transition duration-200">
                Terms of Service
              </a>{' '}
              and{' '}
              <a href="#" className="text-blue-600 hover:text-blue-800 transition duration-200">
                Privacy Policy
              </a>
            </label>
          </div>
          {errors.tAndC && <p className="text-red-500 text-sm mt-1">{errors.tAndC}</p>}

          <button
            type="submit"
            className="w-full bg-blue-600 text-white py-3 px-4 rounded-lg hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition duration-200 font-medium whitespace-nowrap cursor-pointer"
          >
            Create Account
          </button>
        </form>

        <div className="mt-6 text-center">
          <p className="text-gray-600">
            Already have an account?{' '}
            <Link to="/login" className="text-blue-600 hover:text-blue-800 font-medium transition duration-200">
              Sign in
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Signup;